import React from "react";
import styled from "styled-components";
import { useLocation } from "wouter";
import { useToday } from "src/hooks/useToday";
import { ArrowRightIcon, CircleAlert } from "lucide-react";
import { getLocalDate } from "src/database/utils/localDate";

interface Props {
  date: string;
}

export function TodayWarning({ date }: Props) {
  const [, navigate] = useLocation();
  const today = getLocalDate(useToday());

  const notToday = date !== today;

  return notToday ? (
    <Warning>
      <CircleAlert size={16} />
      <WarningText>You are not viewing the current day</WarningText>
      <Button onClick={() => navigate(`/focus/${today}`)}>
        <span>Jump</span>
        <ArrowRightIcon size={12} />
      </Button>
    </Warning>
  ) : null;
}

const Warning = styled.div`
  padding: 5px 5px 5px 15px;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 10px;
  background: var(--box-color);
  @media (max-width: 600px) {
    margin: 0 -10px;
  }
`;

const WarningText = styled.p`
  margin: 0;
  color: var(--text-secondary-color);
  flex-grow: 1;
`;

const Button = styled.button<{ $small?: boolean }>`
  display: flex;
  gap: 8px;
  align-items: center;
  background: var(--box-color-contrast);
  border: none;
  padding: 4px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 300;
  color: var(--text-primary-color);
  ${({ $small }) => $small && `padding: 4px 8px; font-size: 12px;`}
`;
